import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Pe cine căutăm',
        items: [
            'Medici pentru Valul 1 (deschiderea): medicină internă, cardiologie, diabet zaharat, nutriție și boli metabolice, reumatologie, hematologie, gastroenterologie, dermato-venerologie, medicina muncii. Pentru fiecare specialitate, cel puțin doi medici, ca programul 7–21 să fie acoperit în fiecare zi.',
            'Medici pentru Valul 2 (circa șase luni după deschidere): endocrinologie, urologie, pediatrie, ORL, alergologie, oftalmologie, pneumologie.',
            'Profesioniști conecși actului medical — de stabilit.',
            'Asistente medicale — una cu studii superioare, celelalte cu studii postliceale —, cu recepția inclusă în fișa postului, și două posturi administrative.'
        ]
    },
    {
        title: 'Ce vă oferim',
        items: [
            'O clădire nouă, dedicată exclusiv actului medical, cu cabinete dotate după normele în vigoare.',
            'Asistente, recepție, sterilizare, program informatic medical și programări gestionate de clinică.',
            'Reguli scrise, aceleași pentru toți, cunoscute înainte de semnare.',
            'Pentru salariați: salariul pe cele trei etape ale primului an și jumătate este afișat pe pagina fiecărui post.'
        ]
    },
    {
        title: 'Salariul, pentru posturile de salariat',
        text: 'Salariul brut lunar pe cele trei etape, după grila EVOO-HR-POL-02-R4. Se indexează anual cu inflația. Debutanții pornesc cu 20 % sub nivelul de stat în Acomodare, niciodată sub salariul minim.',
        table: {
            head: ['Postul', 'Acomodare (lunile 1–6)', 'Aliniere (lunile 7–15)', 'Afiliere (din luna 16)'],
            rows: [
                ['Asistent medical (postliceală) — cabinete și recepție', '5.679 lei', '6.681 lei', '7.683 lei'],
                ['Asistent medical principal (postliceală)', '6.342 lei', '7.461 lei', '8.580 lei'],
                ['Asistent medical principal (studii superioare)', '7.047 lei', '8.291 lei', '9.520 lei'],
                ['Administrativ 1 — gestiune, achiziții, stocuri, mentenanță', '6.327 lei', '7.443 lei', '8.559 lei'],
                ['Administrativ 2 — contabilitate primară, SPS, DPA, PSI, SSM, HR', '6.615 lei', '7.782 lei', '8.949 lei']
            ]
        }
    },
    {
        title: 'Cum candidați',
        items: [
            'Completați formularul online. Durează circa zece minute și construiește profilul dumneavoastră profesional.',
            'Primele întrebări sunt condiții obligatorii: dreptul de liberă practică cu avizul anual, asigurarea de malpraxis, forma de exercitare (pentru colaboratori), cel puțin 20 de ore pe lună și acordul cu principiile noastre; pentru asistente, autorizația OAMGMAMR și programul în ture 07–21.',
            'Vă răspundem în cel mult 5 zile lucrătoare. Dacă profilul se potrivește, vă invităm la o vizită în clinică.',
            'Punctajul calculat de formular ne ajută să ordonăm candidaturile; decizia o ia întotdeauna un om.'
        ]
    },
    {
        title: 'Datele dumneavoastră',
        text: 'Le folosim numai pentru selecție. Dacă nu încheiem un contract, le ștergem după 6 luni — sau după 2 ani, dacă ne dați acordul să vă păstrăm în baza de candidați. Statisticile pieței le facem doar pe date fără nume. Nu vă cerem vârsta, starea civilă sau salariul de până acum. Detaliile sunt în „Politica de confidențialitate”.'
    }
];

function Cariere() {
    return (
        <LegalPage
            eyebrow="Carieră"
            title="Cariere — medici, profesioniști conecși și personal"
            intro="Deschidem în primăvara anului 2027 un centru medical ambulatoriu nou, la Petrești – Sebeș. Căutăm oameni care să rămână: medici colaboratori, asistente medicale și personal administrativ."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default Cariere;
